import { OperatorCompaniesState } from './operator-companies-state.model';

export const INITIAL_OPERATOR_COMPANIES_STATE: OperatorCompaniesState = {
  companies: [],
  isLoading: false,
  error: null,
};
